export class GameSymbol //store
{   
    private combinationLength:Array<number>;
    private multiplier:Array<number>; 
    private bonusSpins:number;
    private type:string;
    private combinationType:string;
    private symbol:number;

    constructor()
    {
     
        
    // private bonusSpins:number;
      
        this.type=null;
        this.symbol=null;
        this.combinationType=null;
        this.combinationLength=[];
        this.multiplier=[];
        this.bonusSpins=null

    }
    public addToMultiplier=(newVal:number):void=>
    {
        this.multiplier.push(newVal);
        // console.log(this.multiplier)
    }
    public addToCombinaisonLength=(newVal:number):void=>
    {
        this.combinationLength.push(newVal)
    }
    public setBonus=(newVal:number):void=>
    {
        if(this.bonusSpins==null){this.bonusSpins=newVal}
    }

    public setType=(newType:string):void=>
    {
        if(this.type==null){this.type=newType}
    }

    public setSymbol=(newS:number):void=>
    {
        if(this.symbol==null){
            this.symbol=newS
            // console.log(newS)
        }
    }

    public setCombinationType=(newVal:string):void=>
    {
        if(this.combinationType==null){this.combinationType=newVal}
     }
//-------getter
     public getMultiplier=():Array<number>=>
     {
         return this.multiplier;
     }

     public getCombinaisonLength=():Array<number>=>
     {  
        //  console.log(this.symbol)
         return this.combinationLength;
     }
     public getType=():string=>
     {
         return this.type;
     }
     public getCombinationType=():string=>
     {
        return this.combinationType;
    }
    public getSymbol=():number=>
    {
        return this.symbol;
    }
    public getBonus=():number=>
    {
        return this.bonusSpins;
    }

    //-------sorting
    // private sortCroissent(array:Array<number>)
    // {

    // }
}